import React, { useEffect, useState } from 'react';
import { Loader as RsuiteLoader } from 'rsuite';
import { REDESIGN_ENABLED } from '../../../config/config.js';
import './Loader.css';
/**
 * Branded loader for the redesign; RSuite Loader when the flag is off.
 *
 * Gating lives here so every future call site gets the flag-off fallback
 * without a second branch. fill: RSuite `center` (matches DraftGraph's
 * current flag-off). Block: RSuite `vertical` + content.
 *
 * fill only fills the available height and centres the line. A passed
 * message, or "Loading…" when none is passed, sits under that line.
 * wordmark (auth boot) shows the RINF+ wordmark above the line and does not
 * gain the default message. Nothing is shown until delayMs has passed so
 * fast loads do not flash. The status container is rendered from the start
 * (fill keeps its size) so the layout does not jump when the content appears.
 */
const DEFAULT_MESSAGE = 'Loading…';
function Loader({ message, fill = false, wordmark = false, delayMs = 300, }) {
    const [visible, setVisible] = useState(false);
    // Derived from props on this render. A passed message wins; wordmark keeps
    // today's wordmark-and-line with no default text.
    const shownMessage = message || (wordmark ? undefined : DEFAULT_MESSAGE);
    useEffect(() => {
        const id = setTimeout(() => setVisible(true), delayMs);
        return () => clearTimeout(id);
    }, [delayMs]);
    if (!REDESIGN_ENABLED) {
        return fill ? (React.createElement(RsuiteLoader, { center: true, content: message })) : (React.createElement(RsuiteLoader, { vertical: true, content: message }));
    }
    return (React.createElement("div", { className: fill ? 'era-loader era-loader--fill' : 'era-loader', role: "status", "aria-label": shownMessage || 'Loading' }, visible ? (React.createElement(React.Fragment, null,
        wordmark ? (React.createElement("span", { className: "era-loader-wordmark", "aria-hidden": "true" },
            "RINF",
            React.createElement("svg", { className: "era-loader-wordmark-plus", viewBox: "0 0 14 14", "aria-hidden": "true", focusable: "false" },
                React.createElement("path", { d: "M5.2 0h3.6v14H5.2zM0 5.2h14v3.6H0z" })))) : null,
        fill && shownMessage ? (React.createElement("span", { className: "era-loader-line-slot" },
            React.createElement("span", { className: "era-loader-line", "aria-hidden": "true" }),
            React.createElement("span", { className: "era-loader-message" }, shownMessage))) : (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "era-loader-line", "aria-hidden": "true" }),
            shownMessage ? (React.createElement("span", { className: "era-loader-message" }, shownMessage)) : null)))) : null));
}
Loader.displayName = 'Loader';
export { Loader };
